'use client';

import dynamic from 'next/dynamic';
import type { TextPromptWithInputItem } from '@/app/types';
import type { HeroToolType, LocalImage } from '../../../../types';

interface HeroInputFormProps {
  textPrompt: TextPromptWithInputItem;
  referenceImages: LocalImage[];
  toolType?: HeroToolType | null;
  onCreate: () => void;
  onChangePrompt: (value: TextPromptWithInputItem) => void;
  onImageUpload: (file: File) => void;
  onRemoveImage: (index: number) => void;
}

function HeroInputFormSkeleton() {
  return (
    <div
      className="flex min-h-[184px] flex-col rounded-[20px] border border-white/[0.08] bg-[rgba(38,38,38,0.8)] backdrop-blur-[32px]"
      aria-busy="true"
      aria-label="hero input loading"
    >
      <div className="relative px-5 pt-5 pb-4">
        <div className="min-h-[96px] select-none text-sm text-white/30 leading-7">Start with an idea or task.</div>
      </div>
      <div className="flex items-center justify-between px-5 pb-5">
        <div />
        <div className="flex h-9 items-center justify-center rounded-[14px] bg-white/40 px-5 font-medium text-[#0d0d0f] text-[13px]">
          Create
        </div>
      </div>
    </div>
  );
}

const DynamicHeroInputForm = dynamic<HeroInputFormProps>(() => import('./HeroInputFormImpl'), {
  ssr: false,
  loading: () => <HeroInputFormSkeleton />,
});

export function HeroInputForm(props: HeroInputFormProps) {
  return <DynamicHeroInputForm {...props} />;
}
